import * as React from 'react';
import { Dispatch } from 'redux';
import { EventViewModel } from 'stageclip-common';

import { BaseApiGetRequest } from '../generic/baseApiGetRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as EventNormalizers from '../normalizers/eventNormalizers';

export class GetEventRequest extends BaseApiGetRequest<
  EventViewModel,
  EntityNormalizers.NormalizedSingleEntity<EventNormalizers.NormalizedEvents>
> {
  constructor(eventId: string, component: React.Component, dispatch: Dispatch) {
    super(component, dispatch);
    this.path = `/events/${eventId}`;
    this.normalizeMethod = EventNormalizers.normalizeEvent;
  }
}
